import { forwardRef } from 'react';

import {
  IconInput,
  IconInputProps,
} from 'components/Toolkit/Inputs/InputWithIcon';

import { CDN_STATIC_ASSETS } from '../../../utils';

type RegistrationNumberFieldProps = Omit<IconInputProps, 'icon'> & {
  onChange: (value: string) => void;
};

const RegistrationNumberField = forwardRef<
  HTMLInputElement,
  RegistrationNumberFieldProps
>((props, ref) => {
  const { onChange, placeholder = 'e.g. 191D12646', ...rest } = props;

  const onChangeWithValidation = (value: string) => {
    const formattedValue = value.replace(/[^0-9a-z]/gi, '').toUpperCase();
    onChange(formattedValue);
  };

  return (
    <IconInput
      {...rest}
      icon={`${CDN_STATIC_ASSETS}/images/illustrations/eu-symbol-v2.svg`}
      placeholder={placeholder}
      onChange={onChangeWithValidation}
      ref={ref}
    />
  );
});

RegistrationNumberField.displayName = 'RegistrationNumberField';

export { RegistrationNumberField };
